import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import BestFindsPage from "@/pages/articles/best-finds/page";
import ComparisonPage from "@/pages/articles/comparison/page";
import BeginnersPage from "@/pages/articles/beginners/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hipobuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/best-hipobuy-finds-2026",
    element: <BestFindsPage />,
  },
  {
    path: "/hipobuy-spreadsheet-comparison",
    element: <ComparisonPage />,
  },
  {
    path: "/hipobuy-spreadsheet-beginners",
    element: <BeginnersPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;